import { useState, FC, useEffect } from 'react';
import { translate } from 'translations';
import { AccordionTable, CollapseTableData } from 'learning-panel-components';
import { coreService } from 'network-utils';
import { UserData } from '../userLeaderboard/userLeaderboard';
import { getRow } from '../challengeTeamLeaderboard';
import InnerTableContainer from './innerTableContainer';

const TeamLeaderboard: FC<TeamLeaderboardProps> = (props: TeamLeaderboardProps) => {
    const { teams, myTeams, onLoadMore, hasMore, totalTeams, teamsUsersOpenState, onChangeOpenMode, searchString } =
        props;

    const [allTeamsRows, setAllTeamsRows] = useState<CollapseTableData[]>([]);
    const [myTeamsRows, setMyTeamsRows] = useState<CollapseTableData[]>([]);
    const [myTeamsIsOpen, setMyTeamsIsOpen] = useState<boolean>(true);
    const [allTeamsIsOpen, setAllTeamsIsOpen] = useState<boolean>(true);
    const membersNumberText = translate('members');

    const mapTeams = (teams: coreService.HomeTeamLeaderboard[], teamType: string) =>
        teams.map((team: coreService.HomeTeamLeaderboard, i: number) => ({
            row: getRow(
                {
                    rank: team.rank,
                    name: team.name,
                    score: team.totalScore,
                    teamMembers: team.membersCount,
                    profilePicture: '',
                    changeOpenMode: () => onChangeOpenMode(team.name, teamType)
                },
                teamType === 'all' ? i : -1,
                membersNumberText
            ),
            innerTable: (
                <InnerTableContainer
                    isOpen={teamsUsersOpenState[`${String(team.name)}-${teamType}`]}
                    teamUuid={team.uuid}
                    searchString={searchString}
                />
            ),
            isCollapseAble: true,
            isOpen: teamsUsersOpenState[`${String(team.name)}-${teamType}`]
        }));

    useEffect(() => {
        setAllTeamsRows(mapTeams(teams, 'all'));
    }, [teams, teamsUsersOpenState]);

    useEffect(() => {
        setMyTeamsRows(mapTeams(myTeams, 'my'));
    }, [myTeams, teamsUsersOpenState]);

    return (
        <div>
            {myTeamsRows.length > 0 && (
                <AccordionTable
                    rows={myTeamsRows}
                    title={translate('myTeams')}
                    isOpen={true}
                    hasMoreRows={hasMore}
                    loadMoreRows={onLoadMore}
                    tableHeight={allTeamsIsOpen ? '19rem' : '39.5rem'}
                    setIsOpen={(isOpen: boolean) => setMyTeamsIsOpen(isOpen)}
                    titleCount={myTeams.length}
                />
            )}
            <AccordionTable
                rows={allTeamsRows}
                title={translate('allTeams')}
                isOpen={true}
                hasMoreRows={hasMore}
                loadMoreRows={onLoadMore}
                tableHeight={myTeamsRows.length > 0 && myTeamsIsOpen ? '19rem' : '39.5rem'}
                setIsOpen={(isOpen: boolean) => setAllTeamsIsOpen(isOpen)}
                titleCount={totalTeams}
            />
        </div>
    );
};

interface TeamLeaderboardProps {
    teams: coreService.HomeTeamLeaderboard[];
    myTeams: [];
    onLoadMore: Function;
    hasMore: boolean;
    totalTeams: number;
    teamsUsersOpenState: { [teamId: string]: boolean };
    onChangeOpenMode: Function;
    searchString: string;
}

export interface MyTeamUserData extends UserData {
    teamId: number;
}

export interface RowData {
    rank: number;
    name: string;
    teamMembers?: number;
    score: number;
    profilePicture?: string;
}

export default TeamLeaderboard;
